export default __webpack_public_path__ + "402e0acc4c5931a7f6e11117f9654bc5.png";